<div class="agent-chat-toolbar">
  <div class="agent-chat-toolbar-content max-width-agent-chat">
    <div class="toolbar-buttons">
      <a id="backtoAgents" (click)="backToAgents()" class="back-to-agents">
        <img src="../assets/icons/arrows/arrowLeft.svg"> Back to Agents</a>

      <div class="agent-chat-toolbar-buttons">
        <button kmdFeaturedButton class="agent-btn mobile" (click)="navigateToAgentChat()">
          <img class="icon-new-agent" src="../../../assets/icons/plus/plus-16px-mono.svg">New Chat
        </button>
      </div>
    </div>
    <div class="agent-name-like-container">
      <div class="agent-information">
        <h1 class="line-trim">{{ agent?.name }}</h1>
        <div class="agent-rating-container">
          <app-likes-count
            *ngIf="displayRating()"
            agent-rating
            [liked]="agent?.rating?.likedByUser || false"
            [likesCount]="this.agent?.rating?.likes || 0"
            [likeCountOnly]="false"
            [tooltipText]="'You can choose to like the agent after chatting with it.'"/>
        </div>

        <p class="last-update" *ngIf="isPublicAgent() && agent?.updated">
          Last update: {{ getFormattedDate(agent?.updated!) }}
        </p>
      </div>
      <button kmdFeaturedButton class="agent-btn desktop" (click)="navigateToAgentChat()">
        <img class="icon-new-agent" src="../../../assets/icons/plus/plus-16px-mono.svg">New Chat
      </button>
    </div>
    <p class="agent-description line-trim">{{ agent?.description }}</p>
  </div>
</div>
<app-chat-wrapper *ngIf="!loadingChat; else loading"
  [contentPosition]="'bottom'"
  [isStreamingResponse]="isStreamingResponse"
  [promptInputConfig]="promptInputConfig"
  (promptSubmit)="onPromptSubmit($event)"
  (stopStreaming)="stopStreaming()"
  [agent]="agent"
  [ratingEnabled]="agentRatingEnabled && isPublicAgent()"
  [showImageManager] = "hasCompletedResponse"
  (agentRated)="agentRatedEvent($event)">
  <div class="empty-message-container" *ngIf="messages.length === 0 && !loadingChat" [ngClass]="{ 'news-banner-displayed': bannerEnabled }">
    <p id="guidelines-notice-msg">
      Remember to check any Agent responses for accuracy.
      NOTE: Agents should <strong>not</strong> be relied upon for legal or
      scientific advice or be used for making decisions about people.
      For more guidelines relating to Agents,
      please see the <a href="/guidelines" target="_blank">Gene.AI Guidelines</a>.
    </p>
    <img id="agent-avatar-image" src="../../../../assets/images/agent-avatar.png" />
    <h2 id="agent-name" class="line-trim">{{ agent?.name }}</h2>
    <p id="empty-message-agent-description" class="line-trim" *ngIf="!hasConversationStarters(); else conversationStarters">
      {{ agent?.description }}
    </p>
    <ng-template #conversationStarters>
      <app-agent-conversation-starter [conversationStarters]="agent?.conversationStarters!"
        (conversationStarterEvent)="handleConversationStarter($event)">
      </app-agent-conversation-starter>
    </ng-template>
  </div>
  <div id="chat-container" #chatContainer (scroll)="onScroll($event)">
    <div class="messages-wrapper">
      <div class="message-bubble" *ngFor="let msg of messages">
        <ng-container *ngIf="msg.user">
          <app-user-message [chatMessage]="msg.user.content" [type]="userMessageTypeConstant.AGENT" (thumbnailReferencesExpanded)="skipAutoScroll()"/>
        </ng-container>
        <ng-container *ngIf="msg.assistant">
          <ng-container *ngIf="!msg.isGenerating; else generatingResponse">
            <ng-container *ngIf="msg.assistant | async as assistantMsg">
              <app-assistant-message [type]="AssistantMessageTypeConstant.AGENT" #assistantMessage [messageNode]="assistantMsg" [isGeneratingResponse]="false"
                [isMessageCompleted]="isMessageCompleted" [imageCache]="imageCache"
                (activeMessageChange)="onActiveAssistantMessageChange($event)" />
            </ng-container>
          </ng-container>
          <ng-template #generatingResponse>
            <app-assistant-message [type]="AssistantMessageTypeConstant.AGENT" #assistantMessage [isGeneratingResponse]="true" [imageCache]="imageCache" />
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
  <app-news-banner
    *ngIf="showNewsBanner"
    class="banner-modal"
    [headerTitle]="bannerModalTitle"
    [type]="'AGENT_CHAT'"
    (close)="hideNewsBanner()">
    <ng-container *ngIf="featureFlags.newsBannerWebSearch; else PreviousNewsBanner">
      <div>Web search is part of this Agent's configuration and cannot be modified in this chat. You can view its status in the Agent overview.
        <a target="_blank" class="a-announced-feature" [href]="bannerLearnMoreUrl">Learn more.</a></div>
    </ng-container>
  </app-news-banner>
</app-chat-wrapper>
<ng-template #loading>
  <div class="loading-wheel-wrapper">
    <kmd-loading-wheel *ngIf="loadingChat"></kmd-loading-wheel>
  </div>
</ng-template>
<ng-template #PreviousNewsBanner>
  <div>Use the paperclip to upload these new file types. <a target="_blank" class="a-announced-feature" [href]="bannerLearnMoreUrl">Learn more.</a></div>
</ng-template>
